import OfferGenerationWizard from './OfferGenerationWizard';
import sendMutation from '../../../../utils/rest/sendMutation';
import type { HandleRequestOffer } from '../../../../domain/customerInquiry';
import { buildCustomerInquiryFormData } from '../../inquiry/customerInquiryPayloadUtils';

const handleRequestOffer: HandleRequestOffer = async (values) => {
  try {
    const formData = buildCustomerInquiryFormData(values);
    const result = await sendMutation('POST', '/customerinquiry', formData);
    if (result.error) {
      return result.error;
    }
    return false;
  } catch (e) {
    return e instanceof Object ? e : { error: e };
  }
};

function OfferGenerationWizardContainer() {
  return <OfferGenerationWizard handleRequestOffer={handleRequestOffer} />;
}

export default OfferGenerationWizardContainer;
